import { render } from "./SectionsList.vue?vue&type=template&id=5fe6164a"
import script from "./SectionsList.vue?vue&type=script&lang=js"
export * from "./SectionsList.vue?vue&type=script&lang=js"

import "./SectionsList.vue?vue&type=style&index=0&id=5fe6164a&lang=scss"

import exportComponent from "/builds/frontend/landings/mobigiru.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__